import Login from './pages/login/login';

document.addEventListener('DOMContentLoaded', (e) => {
  new Login().init();
});
